import { DeliveryLineStatus } from '@common/enums';
import { FormikConfig } from 'formik';

import { ProjectWeightReceiptInfo } from '~/@user-store/weightReceipts/projectWeightReceipts.store';
import { IProject } from '~/@views/UserView/ProjectPage/ProjectMassesDetails/types';
import { DeliveryLineOrderChangeInput, DeliveryLineSenderUpdateInput } from '~/graphql';
import i18n from '~/i18n';
import { parseDateFrom } from '~/utils/date';

import { getDeliveryLineValidationSchema, IDeliveryLineFormValues } from './DeliveryLineFormikCommon';

export function getDeliveryLineUpdateFormikConfig(
    updateDeliveryLine: (input: DeliveryLineSenderUpdateInput) => Promise<unknown>,
    changeDeliveryLineOrder: (input: DeliveryLineOrderChangeInput) => Promise<unknown>,
    project: IProject,
    deliveryLine: ProjectWeightReceiptInfo
): FormikConfig<IDeliveryLineFormValues> {
    return {
        initialValues: {
            project,
            deliveryLine,
            dumpLoad: {
                id: '',
                serialNumber: deliveryLine.orderNumber,
                inbound: true,
                status: null,
            },
            weight: deliveryLine.weight,
            date: parseDateFrom(deliveryLine.plannedStartDate),
            truckRegistrationNumber: deliveryLine.truckRegistrationNumber,
            truckCapacity: deliveryLine.truckCapacity,
            receipt: null,
            senderComment: deliveryLine.senderComment || '',
            driverComment: deliveryLine.driverComment || '',
            vehicleType: deliveryLine.vehicleType,
            fuel: deliveryLine.fuel,
            engine: deliveryLine.engine,
            status: {
                value: deliveryLine.status,
                label: i18n.DeliveryLineStatuses[deliveryLine.status],
            },
            isVerified: deliveryLine.status === DeliveryLineStatus.VERIFIED,
        },
        validationSchema: getDeliveryLineValidationSchema(undefined, deliveryLine),
        onSubmit: async (values, { resetForm }) => {
            const {
                weight,
                date,
                truckRegistrationNumber,
                truckCapacity,
                receipt,
                vehicleType,
                fuel,
                engine,
                status,
                dumpLoad,
                senderComment,
                driverComment,
            } = values;

            if (!dumpLoad || !date || !vehicleType) return;

            const input: DeliveryLineSenderUpdateInput = {
                id: deliveryLine.id,
                weight,
                plannedStartDate: date.toISOString(),
                truckRegistrationNumber,
                truckCapacity,
                status: status.value,
                vehicleTypeId: vehicleType.id,
                fuel,
                engine,
                senderComment,
                driverComment,
            };

            if (receipt) input.receipt = receipt;

            if (dumpLoad.serialNumber !== deliveryLine.serialNumber) {
                await changeDeliveryLineOrder({
                    id: deliveryLine.id,
                    orderNumber: dumpLoad.serialNumber,
                });
            }

            await updateDeliveryLine(input);
            resetForm();
        },
    };
}
